export default __webpack_public_path__ + "static/media/central.7217a790.png";